import { sendEventV2 } from '@/utils/analytics';
import { appVersion } from '@/utils/version';

const API_BASE = '/.proxy/acf';
let QUEST_ID = process.env.PUBLIC_DISCORD_QUEST_ID || ''; // this is overwriten by the quest id value provided by the discord sdk.

interface AuthorizeResponse {
    token: string;
    access_token: string;
}

interface QuestStatusResponse {
    user_id: string;
    quest_id: string;
    enrolled_at: string;
    completed_at: string | null;
    claimed_at: string | null;
}

let auth_token = '';

export function setAuthToken(token: string) {
    auth_token = token;
}

export function setQuestId(id: string) {
    console.log('[Arise] quest id:', id);
    QUEST_ID = id;
}

export function getQuestIdForAnalytics() {
    return QUEST_ID || 'unknown';
}

// The initial call to exchange the auth code for an access token
export async function authorize(code: string): Promise<AuthorizeResponse> {
    const data = await call<AuthorizeResponse>('POST', '/authorize', { code, activityId: getActivityId() });
    return data;
}

export async function register() {
    return await call<{ authToken: string }>('POST', '/arise/register');
}

export async function checkQuest(): Promise<QuestStatusResponse> {
    if (!auth_token) throw new Error('No auth token set');
    const data = await call<QuestStatusResponse>('GET', '/quest/status');
    return data;
}

// Removed for now, using questProgress with max progress instead
// export async function completeQuest(): Promise<void> {
//     await call('POST', '/quest/complete');
// }
export async function questProgress(progress: number): Promise<{ wasSuccessful: boolean; message?: string }> {
    type QuestProgressResponse = { status: 'ok' } | { status: 'error'; message: string };
    try {
        const response = await call<QuestProgressResponse>('POST', '/quest/progress', { progress });
        const wasSuccessful = response?.status === 'ok';
        const message = wasSuccessful ? undefined : response?.message;
        return { wasSuccessful, message };
    } catch (e: any) {
        let message = '';
        try {
            message = (e as Error).message;
        } catch (e) {}

        return { wasSuccessful: false, message };
    }
}

export async function botRegister(locale: string): Promise<void> {
    await call('POST', '/bot/register', { locale });
}

async function call<T>(method: string, endpoint: string, body?: any, timeout = 10000): Promise<T> {
    const abort = new AbortController();
    setTimeout(() => abort.abort(), timeout);

    const activityId = getActivityId();

    const res = await fetch(API_BASE + endpoint, {
        method,
        headers: {
            'Content-Type': 'application/json',
            'X-Auth-Token': auth_token || '',
            'X-Universe-ID': process.env.PUBLIC_INSTANCE_ID || '',
            'X-Discord-Quest-ID': QUEST_ID,
            'X-Discord-Activity-Id': activityId,
            'X-Discord-Hostname': window.location.hostname,
            'X-Arise-Client': appVersion,
        },
        body: body ? JSON.stringify(body) : undefined,
        signal: abort.signal,
    });
    if (!res.ok) {
        const text = await res.text();
        if (endpoint == '/authorize') {
            sendEventV2('discord-authorize-error', [res.status.toString(), text, window.location.hostname]);
        }
        console.error(
            `[AriseDiscordAPI] ${method} ${endpoint} failed (${res.status}):`,
            text,
            window.location.hostname,
        );
        throw new Error(`${method} ${endpoint} failed with status ${res.status} : ${text}`);
    }
    return res.json();
}

function getActivityId() {
    return window.location.hostname.split('.')[0];
}
